import { render, staticRenderFns } from "./region-list-table.vue?vue&type=template&id=07f93c36&scoped=true&"
import script from "./region-list-table.vue?vue&type=script&lang=js&"
export * from "./region-list-table.vue?vue&type=script&lang=js&"
import style0 from "./region-list-table.vue?vue&type=style&index=0&id=07f93c36&lang=scss&scoped=true&"
import style1 from "./region-list-table.vue?vue&type=style&index=1&id=07f93c36&lang=scss&scoped=true&"
import style2 from "./region-list-table.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f93c36",
  null
  
)

export default component.exports
import {QTable,QInnerLoading,QSpinnerIos,QInput,QIcon,QTr,QTh,QTd,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QInnerLoading,QSpinnerIos,QInput,QIcon,QTr,QTh,QTd,QBtn})
